import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PieceProductCarouselComponent } from './piece-product-carousel.component';

import { AssetsSharedService } from '@features/cms-render/ui/services/assets-shared/assets-shared.service';
import { LazyLoadModule } from '@shared/lazy-load/lazy-load.module';
import { ProductModule } from '@shared/product/product.module';

@NgModule({
    declarations: [
        PieceProductCarouselComponent,
    ],
    imports: [
        CommonModule,
        LazyLoadModule,
        ProductModule,
    ],
    providers: [
        AssetsSharedService,
    ],
    exports: [
        PieceProductCarouselComponent,
    ],
})
export class PieceProductCarouselModule {
    public get pieceProductCarousel() {
        return PieceProductCarouselComponent;
    }
}
